import styled, { css } from 'styled-components';
import { StyledButton } from 'components/button/Button.styles';
import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import theme from 'styles/theme';

/**
 * TODO: replace hardcoded color values with references to the Design System
 * once available. CC: @guido
 */
export const TEXT_PRIMARY = '#292738';
export const TEXT_BLUE = '#26238f';
export const BLUE_DARK = '#1f1c79';
export const SURFACE_BLUE_SUBTLE = '#e6eaf8';
export const SURFACE_BLUE_SECONDARY = '#a0ace0';
export const TEXT_NEUTRAL = '#4e4d5c';

/**
 * TODO: substitute with the new Button from the Hostfully
 * Design System once it is available. CC: @guido
 */
const ctaStyles = css`
  align-items: center;
  border-radius: 1000px;
  display: inline-flex;
  font-size: 16px;
  font-weight: 600;
  height: 40px;
  justify-content: center;
  line-height: 1.4;
  padding: 8px 16px;
  text-decoration: none;
`;

export const primaryCtaStyles = css`
  ${ctaStyles}
  background: ${theme.colors.hostfullyBlue};
  border: 1px solid ${theme.colors.hostfullyBlue};
  color: #fff;

  &:hover,
  &:focus-visible {
    background: ${BLUE_DARK};
    border-color: ${BLUE_DARK};
    color: #fff;
    text-decoration: none;
  }

  &[disabled],
  &[disabled]:hover,
  &[disabled]:focus {
    background: ${theme.colors.hostfullyBlue};
    border-color: ${theme.colors.hostfullyBlue};
    color: #fff;
  }
`;

export const outlineCtaStyles = css`
  ${ctaStyles}
  background: transparent;
  border: 1px solid ${theme.colors.hostfullyBlue};
  color: ${theme.colors.hostfullyBlue};

  &:hover,
  &:focus-visible {
    background: ${SURFACE_BLUE_SUBTLE};
    color: ${theme.colors.hostfullyBlue};
    text-decoration: none;
  }

  &[disabled],
  &[disabled]:hover,
  &[disabled]:focus {
    background: transparent;
    border-color: ${theme.colors.hostfullyBlue};
    color: ${theme.colors.hostfullyBlue};
  }
`;

export const PrimaryCtaButton = styled(StyledButton)`
  ${primaryCtaStyles}
`;

export const OutlineCtaButton = styled(StyledButton)`
  ${outlineCtaStyles}
`;

export const ModalApplyCtaButton = styled(ModalFormSubmitButton)`
  ${primaryCtaStyles}
`;

export const ModalCancelCtaButton = styled(ModalFormCancelButton)`
  ${outlineCtaStyles}
`;
